import React from 'react'
import MyNavbar from '../../components/Navbar/MyNavbar'
import MarketingAgent from '../../components/user/MarketingAgent/MarketingAgent'

export default function MarketingAgentPage() {
    return (
        <div>
            <MyNavbar/>
            <MarketingAgent/>
        </div>
    )
}
